import Image from "next/image";

type TrustPilotProps = {
  link: string;
  trustpilotImage: string;
};

function TrustPilotFooter({
  trustpilotImage,
  link,
}: Readonly<TrustPilotProps>) {
  const imgSrc = `${process.env.NEXT_PUBLIC_MGNL_HOST}/dam/${trustpilotImage}`;

  return (
    <div className="flex py-spacing-m lg:px-spacing-xl px-spacing-m justify-center items-center bg-transparent-overlay lg:rounded-t-none rounded-b-radius-xxl">
      <div className="justify-center items-center max-w-[140px] w-full">
        <a href={link} target="_blank" rel="noreferrer">
          <Image
            loader={() => imgSrc}
            src={imgSrc}
            alt="image"
            width={1500}
            height={800}
          />
        </a>
      </div>
    </div>
  );
}

export default TrustPilotFooter;
